import appApi from "@/api/appApi";
import { getPaginationData, formattedRequest } from "@/core/util/queries";

export default {
  async fetchTournaments() {
    const { data } = await appApi.get("/tournament/index");
    return data;
  },

  checkParticipation() {
    return formattedRequest(() => appApi.get("/tournament/participation"));
  },

  async getInfo(id = 0) {
    const { data } = await appApi.get(`/tournament/view?id=${id}`);
    return data;
  },

  async getBracket(id = 0) {
    const { data } = await appApi.get(`/tournament/grid?id=${id}`);
    return data;
  },

  async getMatches(id = 0, opts = {}) {
    const { data, headers } = await appApi.get("/tournament/matches", {
      ...opts,
      params: Object.assign({}, opts.params || {}, { id })
    });

    return {
      matches: data,
      ...getPaginationData(headers)
    };
  },

  async getPlayers(id = 0, opts = {}) {
    const options = {
      ...opts,
      params: Object.assign({}, opts.params || {}, { id })
    };

    const { data, headers } = await appApi.get("/tournament/players", options);

    return {
      players: data,
      ...getPaginationData(headers)
    };
  },

  async getRules(id = 0) {
    const { data } = await appApi.get(`/tournament/rules?id=${id}`);
    return data;
  },

  async getPlayersCount(id = 0) {
    const params = { id };
    const { data } = await appApi.get("/tournament/players-count", { params });
    return data;
  },

  async tournamentRegister(id = 0) {
    const params = { id };
    const { data } = await appApi.post(
      "/tournament/participate",
      {},
      { params }
    );
    return data;
  },

  checkInTournament(id) {
    const params = { id };
    return formattedRequest(() =>
      appApi.get("/tournament/confirm-participation", { params })
    );
  },

  cancelRegistration(id) {
    const params = { id };
    return formattedRequest(() =>
      appApi.get("/tournament/cancel-participation", { params })
    );
  }
};
